// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flight-hotel-form {\n  margin: 20px 10px 10px 10px;\n}\n", ""]);
// Exports
module.exports = exports;
